module.exports = __webpack_public_path__ + "static/media/Season.40b4ed50.svg";